/**
 * 订单管理 - 交易中止
 * */
import { createStore } from '@souche-f2e/muji';
import Api from '@/services';
import { uniqueArr } from '@/shared/functions';
import Mapping from '@/shared/mapping';
const initData = {
    orderData: {},
    tableData: [],
    totalNumber: 0,
    pageCurrent: 1,
    pageSize: 20,
    searchData: {},
    visible: false,
    goodsId: '',
    exportObjParams: {},
};
export default createStore({
    state: Object.assign({}, initData),
    effects: {
        // desc 更新表格
        updateTable(index, { state }) {
            const { searchData, pageCurrent, pageSize } = state;
            const searchParams = {
                provinceCode: searchData && searchData.provinceCode ? searchData.provinceCode : '',
                cityCode: searchData && searchData.cityCode ? searchData.cityCode : '',
                license: searchData && searchData.license ? searchData.license : '',
                sellerPhone: searchData && searchData.sellerPhone ? searchData.sellerPhone : '',
                vinCode: searchData && searchData.vinCode ? searchData.vinCode : '',
                buyerName: searchData && searchData.buyerName ? searchData.buyerName : '',
                sellerCode: searchData && searchData.sellerCode ? searchData.sellerCode : '',
                buyerPhone: searchData && searchData.buyerPhone ? searchData.buyerPhone : '',
                overTimeDateStar: searchData && searchData.startTime ? searchData.startTime : '',
                overTimeDateEnd: searchData && searchData.endTime ? searchData.endTime : '',
                buyerTypeCode: searchData && searchData.buyerTypeCode,
                sourceType: searchData && searchData.sourceType,
                pageSize,
                pageCurrent: index ? index : pageCurrent + 1,
            };
            Api.order.OrderManageData(searchParams).then((res) => {
                console.log(res, 'res');
                this.SET_STATE({
                    tableData: uniqueArr(res.items),
                    totalNumber: res.totalNumber,
                    pageCurrent: res.currentIndex,
                    exportObjParams: Object.assign(Object.assign({}, searchParams), { totalCount: res.totalNumber, exportType: Mapping.excelExportType.transaction_fail_car.value }),
                });
            });
        },
        // desc 重置数据
        resetState(params) {
            this.SET_STATE(Object.assign(Object.assign({}, initData), params));
        },
    },
    reducers: {
        SET_STATE(state, payload) {
            Object.keys(payload)
                .forEach((key) => {
                if (typeof payload[key] !== 'undefined') {
                    state[key] = payload[key];
                }
            });
        },
    },
});
